import { useNewOrderFunnel } from "../utils/useNewOrderFunnel"
import { OffersSummary } from "../OffersSummary"
import { NewOrderVerificationForm } from "@components/ProspectNew/NewOrderFunnel/Forms/NewOrderVerificationForm"
import { OrderOnlineLink } from "../OrderOnlineLink"

export const Verification = () => {
  const { prospect, shopper, selectedOffer, selectedMarket } =
    useNewOrderFunnel()

  if (!selectedOffer) {
    return (
      <div className="tw-text-sm">
        No offer selected. Return to Choose Offer.
      </div>
    )
  }

  return (
    <div className="tw:flex tw:flex-col tw:gap-6">
      <div className="tw:flex tw:flex-col tw:gap-2">
        <OffersSummary
          data={[selectedOffer]}
          title="Selected Offer"
          includeEnroll={false}
        />
        {shopper?.short_key && (
          <OrderOnlineLink shopper_short_key={shopper.short_key} />
        )}
      </div>
      {prospect?.prospect_guid && shopper && selectedMarket && (
        <NewOrderVerificationForm
          offer={selectedOffer}
          prospect_guid={prospect.prospect_guid}
          shopper={shopper}
          market={selectedMarket}
        />
      )}
    </div>
  )
}
